import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';
import { ReporttemplateService } from "src/app/shared/services/reporttemplate.service";
import { Router } from '@angular/router';
@Component({
    selector: 'app-view-filter',
    template: `
    
  <span *ngFor="let filter of filterName; let i = index; let last = last">
    <a href="#" (click)="onFilterClick($event, filter)">
      {{ filter }}
    </a><span *ngIf="!last">, </span>
  </span>
`,
    standalone: false
})

export class FilterViewButton implements ICellRendererAngularComp {
  dummy: string = 'dummy';
  filterExpanded = false;
  params;
  label: string;
  permissions: number[] = [];
  filterName: string[] = [];
  filterObject={};
  temp:any;
  constructor(private reportService: ReporttemplateService,private router:Router){

  }
  agInit(params): void {
    this.params = params;
    console.log(params);
    this.label = this.params.label || null;
    this.permissions = this.params.values || [];
    this.filterObject = params.filterObject || {};
    this.filterName = typeof params.data.filtername === 'string'
  ? params.data.filtername.split(',') // <-- convert to array
  : Array.isArray(params.data.filtername)
    ? params.data.filtername
    : [];
   
   console.log('Filter Obj', this.filterName); // Debug: should show an array
  }

  refresh(params?: any): boolean {
    return true;
  }

  hasPermission(buttonId: number): boolean {
    return this.permissions.includes(buttonId);
}
  onClick(event: Event): void {
    if (this.params.viewFilter) {
      this.params.viewFilter({ ...this.params.data});
    }
    
  }
 
  async onFilterClick(event: Event,fName: string) {
      // put anything into params u want pass into parents component
      const params = {
        event: event,
        rowData: this.params.node.data,
        filtername:fName
      }
      console.log('Current params:',params);
      console.log('Clicked filter:', fName);
     // this.params.openPanel?.(params);
     await  this.params.openPanel?.(params);
 // this.params.openPanel?.(params); // 👈 calls parent's method
    console.log("FilterName: ",this.filterName);
  }

}